<template>
  <div class="card-container">
    <common-top-form
        selectShowPower="/addPrairies/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/addPrairies/add"
    >
  
      <el-form-item label="模板名称" prop="mercRegisterName">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.mercRegisterName"
          placeholder="请输入模板名称"
        ></el-input>
      </el-form-item>
        <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label="支付方式">-->
      <!--<el-select v-model="formModel.payTypeScope">-->
      <!--<el-option-->
      <!--v-for="item in payTypeScope"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey"-->
      <!--&gt;-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="mercRegisterName"
        label="模板名称"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="brandName"
        label="品牌"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
       <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 1 ? "启用" : "禁用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="qrRate"
        label="扫码费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cloudRate"
        label="云闪付费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="creditRate"
        label="信用卡费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      >
       
      </el-table-column>
      <el-table-column
        prop="debitRate"
        label="借记卡费率(百分比)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="debitStandardCapping"
        label="借记卡封顶(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
        
      <el-table-column
        prop="additionalPro"
        label="D0额外手续费(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="isDeposit"
        label="是否有押金"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isDeposit == 1">是</span>
          <span v-else-if='scope.row.isDeposit != 1'>否</span>

         
        </template>
      </el-table-column>
        <el-table-column
        prop="yajinAmt"
        label="押金金额(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
        <el-table-column
        prop="isSim"
        label="是否有流量费"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isSim == 1">是</span>
          <span v-else-if='scope.row.isSim != 1'>否</span>

         
        </template>
      </el-table-column>
        <el-table-column
        prop="simAmt"
        label="流量费金额(元)"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>

        <!-- <el-table-column
        prop="simFeePayTimes"
        label="扣费周期"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      -->
     
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        v-if="
          hasPerm('/apppointsshopmanage/update') ||
          hasPerm('/apppointsshopmanage/del')
        "
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleStatus(scope.row.id, scope.row.status)"
            class="button-color"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
          <!-- <el-button
            type="text"
            v-if="hasPerm('/apppointsshopmanage/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button> -->
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="'添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="300px"
      dialogWidth="589px"
    >
      <el-form-item label="模板名称" prop="mercRegisterName">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.mercRegisterName"
          placeholder="请输入模板名称"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌编号"  prop="brandCode">
        <el-select style="width: 198px" v-model="dialogModel.brandCode">
          <el-option
            v-for="item in brandCodeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 新增 -->
      <el-form-item label="扫码费率(百分比)" prop="qrRate" style="width: 100%">
         <!-- :min="0.3" -->
          <!-- :max="0.38" -->
              <!-- :step="0.1" -->
        <el-input
          placeholder="请输入0.3%-0.38%"
          :controls="false"
            v-model="dialogModel.qrRate"
          controls-position="right"
          :precision="2"
        prop='qrRate'
          @change="handleChange"
         
          style="width: 180px"
        ></el-input>
        <span>%</span>
      </el-form-item>
      <el-form-item
        label="云闪付费率(百分比)"
        prop="cloudRate"
        style="width: 100%"
      >
        <el-input
          placeholder="请输入0.3%-0.38%"
          :controls="false"
          v-model="dialogModel.cloudRate"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
            prop="cloudRate"
          style="width: 180px"
        ></el-input>
        <span>%</span>
      </el-form-item>
      <el-form-item
        label="信用卡费率(百分比)"
        prop="creditRate"
        style="width: 100%"
      >
        <el-input
          placeholder="请输入0.53%-0.6%"
          :controls="false"
          v-model="dialogModel.creditRate"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
          prop="creditRate"
          style="width: 180px"
        ></el-input>
        <span>%</span>
      </el-form-item>
      <el-form-item
        label="借记卡费率(百分比)"
        prop="debitRate"
        style="width: 100%"
      >
        <el-input
          placeholder="请输入0.5%-0.53%"
          :controls="false"
          v-model="dialogModel.debitRate"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
            prop="debitRate"
          style="width: 180px"
        ></el-input>
        <span>%</span>
      </el-form-item>

      <el-form-item
        label="借记卡封顶(元)"
        prop="debitStandardCapping"
        style="width: 100%"
      >
        <el-input
          placeholder="请输入22-30"
          :controls="false"
          v-model="dialogModel.debitStandardCapping"
          controls-position="right"
         
          :step="0.1"
          @change="handleChange"
           prop="debitStandardCapping"
          style="width: 180px"
        ></el-input>
        <span>元</span>
      </el-form-item>
      <el-form-item
        label="D0额外手续费(元)"
        prop="additionalPro"
        style="width: 100%"
      >
        <el-input
          placeholder="请输入0-3"
          :controls="false"
          v-model="dialogModel.additionalPro"
          controls-position="right"
           prop="additionalPro"
          :step="0.1"
          @change="handleChange"
         
          style="width: 180px"
        ></el-input>
        <span>元</span>
      </el-form-item>
      <el-form-item label="是否有押金">
        <el-radio-group v-model="dialogModel.isDeposit">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="押金金额(元)" style="width: 100%">
        <el-input
          placeholder="请输入"
          :controls="false"
          v-model="dialogModel.yajinAmt"
          controls-position="right"
         
          :step="0.1"
          @change="handleChange"
          style="width: 180px"
        ></el-input>
        <span>元</span>
      </el-form-item> -->
      <el-form-item label="是否有流量费">
        <el-radio-group v-model="dialogModel.isSim">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="流量费金额(元)" style="width: 100%">
        <el-input
          placeholder="请输入"
          :controls="false"
          v-model="dialogModel.simAmt"
          controls-position="right"
          
          :step="0.1"
          @change="handleChange"
          style="width: 180px"
        ></el-input>
        <span>元</span>
      </el-form-item> -->
      <!-- <el-form-item label="扣费周期" prop="name">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.simFeePayTimes"
          placeholder="请输入扣费周期"
            style="width: 180px"
        ></el-input>
      </el-form-item> -->
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import ShopService from "service/ShopService";
import TransactionService from "service/TransactionService";

import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import Institutionlist from "service/Ainstitution";
import Prairies from "service/Prairies";
import ShopPayment from "../ShopManagement/ShopPayment.vue";
export default {
  name: "apppointsshopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
    ShopPayment,
  },
  data() {
    return {
        status: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "开启",
        },
        {
          id: "0",
          value: "关闭",
        },
      ],
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
       mercRegisterName: '',
       status: ''
      },
      tableData: [],
      submitService: Prairies.prairiesList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
          mercRegisterName: '',
        brandCode: "",
        qrRate: '',
        cloudRate: "",
        creditRate: "",
        debitRate: "",
        debitStandardCapping: "",
        additionalPro: "",
        isDeposit: 0,
        yajinAmt: "",
        isSim: 0,
        simAmt: "",
        simFeePayTimes: "",

        // goodName: "",
      },
      payTypeScope: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      dialogRules: {
        mercRegisterName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        brandCode: [
          {
            required: true,
            message: "请选择",
          },
        ],
        qrRate: [
             {
            required: true,
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 0.38 || value < 0.3) {
                callback(
                  new Error(
                    "请重新输入扫码费率0.3%-0.38%"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        cloudRate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 0.38 || value < 0.3) {
                callback(
                  new Error(
                    "请重新输入云闪付费率0.3%-0.38%"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        creditRate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 0.6 || value < 0.53) {
                callback(
                  new Error(
                    "请重新输入信用卡费率0.53%-0.6%"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        debitRate: [
         {
            required: true,
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 0.53 || value < 0.5) {
                callback(
                  new Error(
                    "请重新输入借记卡费率0.5%-0.53%"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        debitStandardCapping: [
         {
            required: true,
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 33 || value < 22) {
                callback(
                  new Error(
                    "请重新输入借记卡封顶22元-33元"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        additionalPro: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log(value)
              if (value > 3 || value < 0) {
                callback(
                  new Error(
                    "请重新输入D0额外手续费0元-3元"
                  )
                );
              } else {
                callback();
              }
            },
          },
        ],
        fee2: [
          {
            required: true,
            message: "请输入",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入",
          },
        ],
        typeTwo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        artNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        goodName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        residueNo: [
          {
            required: true,
            message: "请输入",
          },
        ],
        payTypeScope: [
          {
            required: true,
            message: "请选择",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入",
          },
        ],
        signPrice: [
          {
            required: true,
            message: "请输入",
          },
        ],
        couponGroupId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请选择你要上传的图片",
          },
        ],
      },
      typeList: [
        {
          dictKey: "1",
          dictValue: "每月推荐",
        },
        {
          dictKey: "2",
          dictValue: "积分精品",
        },
        {
          dictKey: "3",
          dictValue: "优惠券",
        },
      ],
      typeTwoList: [],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      couponList: [],
      loading: false,
      brandCodeList: [], // 品牌编号
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("merchantPayType", (res) => {
      this.payTypeScope = [...this.payTypeScope, ...res];
    });
    this.getTypeNames("积分精品商城", (res) => {
      this.typeTwoList = res;
    });
    this.getTypeNames("燎原品牌编号", (res) => {
      this.brandCodeList = res;
    });
  },
  computed: {
    submitData() {
      this.params = {
        mercRegisterName: this.formModel.mercRegisterName,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      const params = {
        mercRegisterName: this.dialogModel.mercRegisterName,
        brandCode: this.dialogModel.brandCode,
        qrRate: this.dialogModel.qrRate,
        cloudRate: this.dialogModel.cloudRate,
        creditRate: this.dialogModel.creditRate,
        debitRate: this.dialogModel.debitRate,
        debitStandardCapping: this.dialogModel.debitStandardCapping,
        additionalPro: this.dialogModel.additionalPro,
        isDeposit: this.dialogModel.isDeposit,
        // yajinAmt: this.dialogModel.yajinAmt,
        isSim: this.dialogModel.isSim,
        // simAmt: this.dialogModel.simAmt,
        // simFeePayTimes: this.dialogModel.simFeePayTimes,
        // goodName: this.dialogModel.goodName,
      };
      
      return params;
    },
    dialogService() {
    
      return Prairies.addPrairies;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "tatSimpleId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        mercRegisterName: "",
        status: ''
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getCouponList();
    },
    // 启用禁用
    handleStatus(id, status) {
      this.showConfirm(`确定${status == 1 ? "禁用" : "启用"}该模板？`)
        .then(() => {
          this.doStatus(id, status);
        })
        .catch(() => {});
    },
    doStatus(id, status) {
      this.doLoad(
        Prairies.openAddprairies,
        {
         
          id: id,
          status: status == 1 ? 0 : 1,
         
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.contents);
            this.getList();
          });
        },
        "信息获取失败"
      );
    },
    getCouponList() {
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 100,
        },
        (res) => {
          this.couponList = res.contents.rows;
        },
        "信息获取失败"
      );
    },

    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        ShopService.apppointsshopmanageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },

    openAddDialog(item, flag) {
         this.dialogModel = {
         mercRegisterName: '',
        brandCode: "",
        qrRate: "",
        cloudRate: "",
        creditRate: "",
        debitRate: "",
        debitStandardCapping: "",
        additionalPro: "",
        isDeposit: 0,
        yajinAmt: "",
        isSim: 0,
        simAmt: "",
        simFeePayTimes: "",
      };
      this.$refs.formDialog.open();
    },
    dialogClose() {
      this.dialogModel = {
         mercRegisterName: '',
        brandCode: "",
        qrRate: "",
        cloudRate: "",
        creditRate: "",
        debitRate: "",
        debitStandardCapping: "",
        additionalPro: "",
        isDeposit: 0,
        yajinAmt: "",
        isSim: 0,
        simAmt: "",
        simFeePayTimes: "",
      };
     
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        console.log('pinppi')
        this.tableData.forEach(item => {
          this.brandCodeList.forEach(itemTwo => {
            console.log(itemTwo)
            if(itemTwo.dictKey == item.brandCode) {
              item.brandName = itemTwo.dictValue
            }
          })
        })
                 console.log(this.tableData,'tableData')
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    beforeAvatarUploadOther(file) {
      this.loading = true;
      console.log(file);
      const isVideo = file.type === "video/mp4";

      const isLt2M = file.size / 1024 / 1024 < 12;
      console.log(isVideo && !isLt2M, isVideo, !isLt2M);
      if (isVideo && !isLt2M) {
        this.loading = false;
        this.$message.error("上传视频大小不能超过 12MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    otherError() {
      this.loading = false;
    },
    formatterTableDataTypeTwo(row, column, cellValue, index) {
      let value = "--";
      if (row.type == 3) {
        return row.couponGroupName ? row.couponGroupName : value;
      }
      if (row.type == 2) {
        return cellValue ? cellValue : value;
      }
      return value;
    },
    formatterTableDataType(row, column, cellValue, index) {
      let value = "--";
      this.typeList.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
        this.loading = false;
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 70px;
  height: 70px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 70px;
  height: 70px;
  border: 1px dashed red;
  border-radius: 6px;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Prairies/addPrairies.vue